import { render } from "./TextBookForm.vue?vue&type=template&id=c2ef3e26"
import script from "./TextBookForm.vue?vue&type=script&lang=js"
export * from "./TextBookForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__